var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.isLoading)?_c('main',[_c('PageBanner',{attrs:{"header":_vm.contactUsView.header,"imageSrc":_vm.imageUrlFor(_vm.contactUsView.headerImage)}}),_c('ContactForm',{attrs:{"header":_vm.contactUsView.formHeader}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }